import { axiosInstance } from "utils/axiosInstance";
import { usersURL } from "utils/urls";

export const meDataServ = async ()=> {
  return await axiosInstance
    .get(`${usersURL}/me`)
    .then((res) => res.data)
    .catch((err) => new Error(err.response ? err.response.data.message : "Request ME failed"));
}
